export const QUESTIONS_STORAGE_KEY = 'pdfValidatorQuestions_v1'
export const FOLLOW_UP_QUESTIONS_STORAGE_KEY = 'pdfValidatorFollowUpQuestions_v1'
export const INTERNAL_QUESTION_ID_PREFIX = 'question_'
export const PDF_STAGE_HEIGHT_PX = 850
export const PDF_STAGE_WIDTH_PX = Math.round((PDF_STAGE_HEIGHT_PX * 210) / 297)

export const STANDARD_CHECK_DEFINITIONS = [
    {
        id: 'standard_check_aktuelle_quellen',
        question: 'Die Marktdaten Quellen sind nicht älter als zwei Jahre vor Wertermittungsstichtag',
    },
    {
        id: 'standard_check_grundbuchauszug',
        question: 'Der Grundbuchauszug ist maximal drei Jahre alt',
    },
    {
        id: 'standard_check_wirtschaftliches_baujahr',
        question: 'Das wirtschaftliche Baujahr hat sich nicht verändert',
    },
    {
        id: 'standard_check_besichtigung_hauptgutachter',
        question: 'Die Besichtigung wurde u.a. durch den Hauptgutachter durchgeführt',
    },
] as const

export const EXAMPLE_QUESTION_TEXTS = [
    'Woraus resultieren die wesentlichen Änderungen zur Vorbewertung?',
    'Wurden die CapEx-Maßnahmen so beschrieben, dass sie für einen unabhängigen Dritten nachvollziehbar sind?',
    'Wurde die Veränderung des LZ so beschrieben, dass sie für einen unabhängigen Dritten nachvollziehbar ist?',
    'Es gibt keine logische Widersprüche im Gutachten. Falls doch, liste alle.',
    'Es gibt keine Rechtschreibfehler im Dokument. Falls doch, liste alle.',
    'Es gibt keine verbleibende Platzhalter im Dokument. Falls doch, liste alle.',
    'Die Gegenüberstellung zur Vorbewertung rechnet die korrekte absolute und prozentuale Veränderung.',
] as const
